import React from 'react';

const Logo = ({ alignItems }: React.CSSProperties) => {
  return <img src={require('../../assests/images/logo_white.png')} alt="" />;
};

export default Logo;
